<app-iota-modal [modalOptions]="modalOptions" (close$)="closeDialog()">
    <span modal-header class="text-lg font-bold" i18n>Edit employee - group change</span>

    <div modal-body class="p-5 flex flex-col items-stretch gap-3">
        <app-employee-group-change-dialog-validation-data
            [employee]="data.employee"
            [groupChangeRequest]="selectedGroupChangeRequest()"
            [officeIdToNameMap]="officeIdToNameMap$ | ngrxPush"
        >
        </app-employee-group-change-dialog-validation-data>

        <div class="divider"></div>

        <div class="w-full grid grid-cols-4 gap-y-2 gap-x-5 items-center" [formGroup]="form">
            <label class="label" for="newEmployeeGroup" i18n>Future employee group</label>
            <div class="col-span-3 flex flex-col gap-1">
                <select class="select select-bordered w-full" formControlName="newEmployeeGroup">
                    <option [ngValue]="null">-</option>
                    <option
                        *ngFor="let employeeGroup of possibleEmployeeGroupsToChange$ | ngrxPush"
                        [ngValue]="employeeGroup"
                        [disabled]="data.employee?.employeeGroup === employeeGroup"
                    >
                        {{ employeeGroup }}
                    </option>
                </select>
                <span class="text-error font-bold" *ngIf="form.get('newEmployeeGroup').dirty && form.get('newEmployeeGroup').invalid" i18n>
                    The field "Future employee group" is mandatory.
                </span>
            </div>

            <label class="label" for="changeDate" i18n>Group change date</label>
            <div class="col-span-3 flex flex-col gap-1">
                <input class="input input-bordered" formControlName="changeDate" type="date" [min]="earliestPossibleDate$ | ngrxPush" />
                <div
                    class="flex flex-col items-start text-error text-xs"
                    *ngIf="form.get('changeDate')?.dirty && form.get('changeDate')?.invalid"
                >
                    <strong *ngIf="form.get('changeDate')?.hasError('required')" i18n> The field "Group change date" is mandatory. </strong>
                    <strong *ngIf="form.get('changeDate')?.hasError('dateIsNotFirstOfMonth')" i18n>
                        The "Group change date" must be the first of a month.
                    </strong>
                    <strong *ngIf="form.get('changeDate')?.hasError('dateIsBeforeMinDate')" i18n>
                        The "Group change date" cannot be earlier than {{ earliestPossibleDate$ | ngrxPush | date: 'dd.MM.yyyy' }}.
                    </strong>
                </div>
            </div>
            <div class="col-span-4 alert alert-warning shadow-lg my-2" *ngIf="isScheduledAndCannotBeModified">
                <div>
                    <iota-icon icon="exclamation-triangle" size="1.5"></iota-icon>
                    <span class="w-full text-sm" i18n>The deadline has been reached, the group change cannot be modified anymore.</span>
                </div>
            </div>
            <div class="col-span-4 alert alert-error shadow-lg my-2" *ngIf="actionError$ | ngrxPush">
                <div>
                    <iota-icon icon="exclamation-triangle" size="1.5"></iota-icon>
                    <span class="w-full text-sm" i18n>There was an error while saving the data. Please contact our support.</span>
                </div>
            </div>
        </div>
    </div>

    <div modal-footer class="flex grow gap-2">
        <button class="btn btn-sm btn-ghost rounded-full" (click)="closeDialog()" i18n>Cancel</button>
        <div class="flex-1"></div>
        <button
            class="btn btn-outline btn-sm rounded-full flex flex-row items-center gap-2"
            *ngIf="showCancelButton"
            [disabled]="isCancelButtonDisabled"
            [ngClass]="{ loading: cancelGroupChangePressed && (actionLoading$ | ngrxPush) }"
            (click)="cancelGroupChange()"
            i18n
        >
            Cancel group change
        </button>
        <button
            class="btn btn-primary btn-sm rounded-full flex flex-row items-center gap-2"
            *ngIf="showSaveButton"
            [disabled]="isSaveButtonDisabled"
            [ngClass]="{ loading: savePressed && (actionLoading$ | ngrxPush) }"
            (click)="save()"
            i18n
        >
            Save
        </button>
    </div>
</app-iota-modal>
